import { useState } from 'react';
import { Tooltip, IconButton, Box } from '@mui/material';
import { PropTypes } from 'prop-types';
// import { webalize } from 'webalize';
// import { useReactToPrint } from 'react-to-print';
// import html2canvas from 'html2canvas';
// import { jsPDF } from 'jspdf';
import useLocales from '../../../hooks/useLocales';
import Iconify from '../../Iconify';
import ShareModal from './ShareModal';
import { GAEvent } from '../../GoogleAnalytics';
// import Heart from '../Cards/Heart';
import DetailHeart from './DetailHearth';

DetailsTooltipsCO.propTypes = {
  printInstance: PropTypes.object,
  // refProp: PropTypes.object,
  title: PropTypes.string,
  heartAction: PropTypes.func,
  favorite: PropTypes.bool,
  size: PropTypes.number,
  licence: PropTypes.number,
  onDownloadClick: PropTypes.func,
  gaEventInfo: PropTypes.any,
};

export default function DetailsTooltipsCO(props) {
  const { title, heartAction, size, favorite, licence, onDownloadClick, printInstance, gaEventInfo } = props;
  const { translate } = useLocales();
  const [showShareModal, setShowShareModal] = useState(false);

  const handlePrint = () => {
    GAEvent('Print', 'Print CO', `${title} - ${gaEventInfo}`);
    window.open(printInstance.url, '_blank');
  };

  // const handlePrint = useReactToPrint({
  //   content: () => refProp.current,
  //   // onBeforeGetContent: () => {
  //   //   document.getElementById('print-icons').style.display = 'none';
  //   //   document.getElementById('print-digital').style.display = 'none';
  //   //   document.getElementById('print-image').style.display = 'flex';
  //   //   document.getElementById('print-metadata').style.maxHeight = 'none';
  //   // },
  //   // onAfterPrint: () => {
  //   //   document.getElementById('print-icons').style.display = 'flex';
  //   //   document.getElementById('print-digital').style.display = 'block';
  //   //   document.getElementById('print-image').style.display = 'none';
  //   //   document.getElementById('print-metadata').style.maxHeight = '480px';
  //   // },
  // });

  /* const handleDownloadPdf = async () => {
    if (licence !== 1) return;
    const element = refProp.current;
    const canvas = await html2canvas(element);
    // eslint-disable-next-line new-cap
    const pdf = new jsPDF('p', 'pt');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const headerHeight = document.getElementById('header').offsetHeight
    const imgData = canvas.toDataURL('image/webp', 0.2);
    const imgHeight = canvas.height * pdfWidth / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;
    heightLeft -= pdfHeight;

    pdf.addImage(imgData, 'PNG', 0, position - (64 + 16) * 0.75, pdfWidth, imgHeight);

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position - headerHeight * 0.75, pdfWidth, imgHeight);
      heightLeft -= pdfHeight;
    }

    pdf.save(`${webalize(title)}.pdf`)
  }; */

  const heart = () => {
    heartAction();
  };

  return (
    <Box className="hidden-print">
      <DetailHeart
        heartAction={
          (/* e */) => {
            heart(/* e */);
          }
        }
        name={props}
        size={24}
        favorite={favorite}
      />
      <Tooltip
        title={translate('default.share')}
        placement="top"
        enterTouchDelay={0}
        arrow
        onClick={() => licence !== 0 && setShowShareModal(true)}
      >
        <span>
          <IconButton disabled={licence === 0} sx={{ color: (theme) => theme.palette.text.primary }}>
            <Iconify icon="ep:share" width={size} height={size} />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip
        title={printInstance.loading === true ? translate('objects.loading') : translate('default.print')}
        placement="top"
        enterTouchDelay={0}
        arrow
        PopperProps={{
          style: { padding: '8px' }, // Add padding to the Popper element
        }}
      >
        <span>
          <IconButton
            aria-label="print"
            disabled={licence === 0 || printInstance.loading === true}
            sx={{ color: (theme) => theme.palette.text.primary }}
            onClick={() => licence !== 0 && printInstance.loading === false && handlePrint()}
          >
            <Iconify icon="fluent:print-20-filled" width={size} height={size} />
          </IconButton>
        </span>
      </Tooltip>
      {onDownloadClick && (
        <Tooltip
          title={translate('default.download')}
          placement="top"
          enterTouchDelay={0}
          arrow
          onClick={onDownloadClick}
        >
          <span>
            <IconButton
              disabled={licence !== 1}
              sx={{ color: (theme) => theme.palette.text.primary, marginRight: '8px' }}
            >
              <Iconify icon="akar-icons:cloud-download" width={size} height={size} />
            </IconButton>
          </span>
        </Tooltip>
      )}
      <ShareModal
        open={showShareModal}
        title={title}
        onClose={() => {
          setShowShareModal(false);
        }}
      />
    </Box>
  );
}
